var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"sr-only"},[_vm._v("International Travel")]),_c('ul',_vm._l((_vm.photos),function(photo){return _c('li',{key:photo._id,staticClass:"photo-list__photo"},[_c('travel-photo',{attrs:{"photo":photo}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }